// BlockRoot moved to @akademi/site-builder-runtime (it only wraps the
// runtime's useBlockRootAttrs hook). Re-exported here so the ~60
// `import { BlockRoot } from '../_shared/BlockRoot'` call sites keep working.
export { BlockRoot, type BlockRootProps } from '@akademi/site-builder-runtime';
